<bic-popup (close)="cancelClicked()" customClass="w-[560px]" title="Koordinationsmodell erstellen">
  <div [formGroup]="coordinationForm" bicPopupContent class="flex flex-col gap-4">
    <div class="flex flex-col">
      <bic-input [errorCondition]="showValidationError" [formControlName]="'name'" [iconStart]="faPenToSquare"
                 [label]="'Name'"
                 [maxLength]="100"
                 [placeholder]="'Koordinationsmodell-Name * (erforderlich)'" [required]="true" [showX]="false"
                 class="w-full">
      </bic-input>
      <!-- Vorher war "Erstellen" nur ausgegraut: unerlaubtes Zeichen, Dublette und leerer Name sahen
           identisch aus. Gleiches Muster wie new-folder.html. -->
      @if (showValidationError) {
        <span class="block mt-2 text-sm text-red-500">{{ validationError }}</span>
      }
    </div>
    <div class="flex flex-col gap-2">
      <span class="text-sm text-gray-500">
        @if (isLoadingFiles) {
          Verknüpfte IFC-Dateien
        } @else {
          Verknüpfte IFC-Dateien ({{ ifcFiles.length }})
        }
      </span>
      <div class="flex flex-col gap-1 max-h-48 overflow-y-auto">
        <!-- Im Viewer-Pfad geht der Dialog vor dem Laden der Projektdateien auf
             (siehe BimViewerService.createCoordinationModel). -->
        @if (isLoadingFiles) {
          <div class="flex flex-row items-center gap-2 px-2 py-4 justify-center">
            <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
            <span class="text-sm font-medium text-gray-500">Modelle werden geladen…</span>
          </div>
        }
        @if (loadErrorMessage) {
          <span class="text-sm text-red-500 px-2 py-1.5">{{ loadErrorMessage }}</span>
        }
        @for (file of ifcFiles; track file.id) {
          <div class="flex items-center gap-2 text-sm text-gray-700 px-2 py-1.5 bg-gray-50 rounded">
            <span class="truncate">{{ file.name }}</span>
          </div>
        }
      </div>
    </div>
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end gap-4">
    <bic-button (onClick)="cancelClicked()" buttonType="white">Abbrechen</bic-button>
    <bic-button (onClick)="saveClicked()" [disabled]="!isValidName()">Erstellen</bic-button>
  </div>
</bic-popup>
